import { Map } from 'immutable';
import { createSelector } from 'reselect';
import { generateTypes } from './helpers/types';
import { BRANCH_LINK_TYPES } from '../../lib/branch';

const INITIAL_STATE = new Map({
  linkType: undefined,
  data: new Map({}),
  downloadLink: undefined,
});

const types = generateTypes('branch', [
  'SET_NEW_CONTACT_LINK',
  'SET_DOWNLOAD_LINK',
]);

export default function branchReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SET_NEW_CONTACT_LINK:
      return state
        .set('linkType', BRANCH_LINK_TYPES.newContact)
        .set('newContactLinkType', action.payload.newContactLinkType)
        .set('newContactToken', action.payload.newContactToken);
    case types.SET_DOWNLOAD_LINK:
      return state.set('downloadLink', action.payload.downloadLink);
    default:
      return state;
  }
}

export function setNewContactLink(newContactLinkType, newContactToken) {
  return {
    type: types.SET_NEW_CONTACT_LINK,
    payload: { newContactLinkType, newContactToken },
  };
}

export function setDownloadLink(downloadLink) {
  return {
    type: types.SET_DOWNLOAD_LINK,
    payload: { downloadLink },
  };
}

export function clearDownloadLink() {
  return {
    type: types.SET_DOWNLOAD_LINK,
    payload: { downloadLink: undefined },
  };
}

const getBranchState = state => state.branch;

export const getLinkType = createSelector(getBranchState, branch => branch.get('linkType'));
export const getNewContactLinkType = createSelector(getBranchState, branch => branch.get('newContactLinkType'));
export const getNewContactToken = createSelector(getBranchState, branch => branch.get('newContactToken'));
export const getDownloadLink = createSelector(getBranchState, branch => branch.get('downloadLink'));
